module.exports = __webpack_public_path__ + "static/media/group-white.4241041b.png";